import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getMarket = (limit = 12) =>
  api.get(`/market/top?limit=${limit}`).then((r) => r.data);

export const getImpact = () => api.get(`/impact/stats`).then((r) => r.data);

export const getRecentPledges = () =>
  api.get(`/pledges/recent`).then((r) => r.data);

export const createPledge = (payload) =>
  api.post(`/pledge`, payload).then((r) => r.data);

const TOKEN_KEY = "aftbrn_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) =>
  api.post(`/auth/login`, { email, password }).then((r) => r.data);

export const adminMe = () => api.get(`/auth/me`, authHeader()).then((r) => r.data);

export const adminGetPledges = () =>
  api.get(`/admin/pledges`, authHeader()).then((r) => r.data);

export const adminBroadcast = (subject, message) =>
  api.post(`/admin/broadcast`, { subject, message }, authHeader()).then((r) => r.data);

export const adminAnnounceLaunch = (presale_url, subject) =>
  api.post(`/admin/announce-launch`, { presale_url, subject }, authHeader()).then((r) => r.data);

export const adminTestLaunch = (presale_url, subject) =>
  api.post(`/admin/announce-launch`, { presale_url, subject, test: true }, authHeader()).then((r) => r.data);

export const adminChangePassword = (current_password, new_password) =>
  api.post(`/admin/change-password`, { current_password, new_password }, authHeader()).then((r) => r.data);

export const adminClearPledges = () =>
  api.delete(`/admin/pledges`, authHeader()).then((r) => r.data);

export const adminDeletePledges = (ids) =>
  api.post(`/admin/pledges/delete`, { ids }, authHeader()).then((r) => r.data);

export const adminSendTrialReport = () =>
  api.post(`/admin/trial-report`, {}, authHeader()).then((r) => r.data);

export const adminClearJunkPledges = () =>
  api.delete(`/admin/pledges/junk`, authHeader()).then((r) => r.data);

export const adminGetSettings = () =>
  api.get(`/admin/settings`, authHeader()).then((r) => r.data);

export const adminUpdateSettings = (payload) =>
  api.post(`/admin/settings`, payload, authHeader()).then((r) => r.data);

export const getTransparency = () =>
  api.get(`/transparency`).then((r) => r.data);

export const adminAddDonation = (payload) =>
  api.post(`/admin/donations`, payload, authHeader()).then((r) => r.data);

export const adminDeleteDonation = (id) =>
  api.delete(`/admin/donations/${id}`, authHeader()).then((r) => r.data);
